import SharedSecNavBar from '@src/components/navigationBar/secondary/SharedSecNavBar'
import { FeatureFlagType } from '@src/constants/featureFlag'
import { NAV_BAR_CONFIG } from '@src/constants/layout'
import { ROUTE } from '@src/constants/route'
import featureAllowed from '@src/util/apeiron/featureAllowed'
import { FC, useMemo } from 'react'

const ALLOW_NEWS = featureAllowed(FeatureFlagType.ShowBattleDemoNews)

export const NAVIGATION_ITEMS = [
  {
    route: ROUTE.BATTLE_DEMO_GAME,
    translationKey: 'sub_bar.battle_demo.game'
  },
  {
    route: ROUTE.BATTLE_DEMO_BEGINNERS_GUIDE,
    translationKey: 'sub_bar.battle_demo.beginners_guide'
  },
  ...(ALLOW_NEWS
    ? [
        {
          route: ROUTE.BATTLE_DEMO_NEWS,
          translationKey: 'sub_bar.battle_demo.news'
        }
      ]
    : []),
  {
    route: ROUTE.BATTLE_DEMO_BATTLE_PASS,
    translationKey: 'sub_bar.battle_demo.pass'
  },
  {
    route: ROUTE.BATTLE_DEMO_ECONOMY,
    translationKey: 'sub_bar.battle_demo.economy'
  },
  {
    route: ROUTE.BATTLE_DEMO_SOLO_PVE,
    translationKey: 'sub_bar.battle_demo.leaderboard_pve'
  },
  {
    route: ROUTE.BATTLE_DEMO_SOLO_PVP,
    translationKey: 'sub_bar.battle_demo.leaderboard_pvp'
  },
  {
    route: ROUTE.BATTLE_DEMO_GUILD_WAR_PVP,
    translationKey: 'sub_bar.battle_demo.guild_war_pvp'
  },
  {
    route: ROUTE.BATTLE_DEMO_VIP_PASS,
    translationKey: 'sub_bar.battle_demo.vip_pass'
  }
]

const NavigationBar: FC<Props> = (props: Props) => {
  const { route } = props

  const index = useMemo(() => {
    return NAVIGATION_ITEMS.findIndex(item => item.route === route)
  }, [route])

  return (
    <SharedSecNavBar
      height={NAV_BAR_CONFIG.secondary.height}
      index={index}
      navigationItems={NAVIGATION_ITEMS}
    />
  )
}

type Props = {
  route: ROUTE
}

export default NavigationBar
